
import TableList from "@components/templates/tablelist";
import { HttpProductList } from "@/service/products/calculationRelease";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    props:['lineId'],
    data() {
        return {
            isMixin: true,
            formData: {
                search: {
                },
            },
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left",
            },
        };
    },
    methods: {
        ajaxRequest: HttpProductList,
        interceptRequest(params) {
            params.search.EQ_status = 0
            return params
        },
    },
    computed: {
		...mapGetters('dictionary', ['getProductList']),
        SearchsData() {
            return [{
                label: "ERP SKU",
                tag: 'vInput',
                key: 'CN_sku',
                show: true,
            },
            {
                label: this.$t('global.common.name', { defaultValue: "名称" }),
                tag: 'vInput',
                key: 'EQ_name',
                show: true,
            },
            {
                label: this.$t('global.common.project', { defaultValue: "项目" }),
                key: 'EQ_lineId',
                tag: 'vSelect',
                options: this.getProductList.map((item) => {
					return {
						value: item.value,
						label: item.attach.name,
					}
				}),
                show: true,
                default: this.lineId
            }]
        },
        columns() {
            return [{
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: "ERP SKU",
                key: 'sku'
            }, {
                title: this.$t('fbb.inbound.CN_name', { defaultValue: "名称(中文)" }),
                key: 'name'
            }, {
                title: this.$t('global.common.En_name', { defaultValue: "名称(英文)" }),
                key: 'nameEn'
            },
            {
                title: this.$t('global.common.operation', { defaultValue: "操作" }),
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, this.$t('fbb.inbound.choose', { defaultValue: "选择" }))
                }
            }]
        }
    }

};
